import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';

export const delightApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllDelightsRequests: builder.query({
      query: () => `${ENDPOINTS.DELIGHT.BASE}`,
      providesTags: (result, error, id) =>
        result
          ? [{ type: 'Delight', id: 'LIST' }, ...result.map(({ _id }) => ({ type: 'Delight', id: _id }))]
          : [{ type: 'Delight', id: 'LIST' }],
    }),
    fetchDelights: builder.query({
      query: ({ empCode }) => `${ENDPOINTS.DELIGHT.BY_REQUESTER}${empCode}`,
      providesTags: (result, error, id) =>
        result?.data
          ? [{ type: 'Delight', id: 'LIST' }, ...result?.data.map(({ _id }) => ({ type: 'Delight', id: _id }))]
          : [{ type: 'Delight', id: 'LIST' }],
    }),
    postDelight: builder.mutation({
      query: (data) => ({
        url: ENDPOINTS.DELIGHT.BASE,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'Delight', id: 'LIST' }],
    }),
    fetchUserData: builder.query({
      query: () => ENDPOINTS.USER.FINDALLPEOPLE, // Adjust the endpoint as per your actual API endpoint
      providesTags: (result, error, id) =>
        result?.data
          ? [{ type: 'Delight', id: 'LIST' }, ...result?.data.map(({ _id }) => ({ type: 'Delight', id: _id }))]
          : [{ type: 'Delight', id: 'LIST' }],
    }),
    updateAdminRequestStatus: builder.mutation({
      query: ({ requestId, adminRejectionReason }) => ({
        url: `${ENDPOINTS.DELIGHT.BASE}/updateAdminStatus/${requestId}`,
        method: 'POST',
        body: { requestId, adminRejectionReason },
      }),
      invalidatesTags: [{ type: 'Delight', id: 'LIST' }],
    }),
    updateHrRequestStatus: builder.mutation({
      query: ({ requestId, hrRejectionReason }) => ({
        url: `${ENDPOINTS.DELIGHT.BASE}/updateHrStatus/${requestId}`,
        method: 'POST',
        body: { requestId, hrRejectionReason },
      }),
      invalidatesTags: [{ type: 'Delight', id: 'LIST' }],
    }),
  }),
});

export const {
  useFetchDelightsQuery,
  usePostDelightMutation,
  useFetchUserDataQuery,
  useGetAllDelightsRequestsQuery,
  useUpdateAdminRequestStatusMutation,
  useUpdateHrRequestStatusMutation,
} = delightApiSlice;
